import type { inferQueryKeys } from '@lukemorales/query-key-factory';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getAuthenticationMethods } from '../apiClient';

export const authenticationQueries = createQueryKeys('authentication', {
  list: () => ({
    queryKey: [''],
    queryFn: () => getAuthenticationMethods(),
  }),
});

export type AuthenticationQueries = inferQueryKeys<typeof authenticationQueries>;
